import PostPageView from "../../components/community/post_pageview";

const AdminPostsScreen = () => {
    return <PostPageView isAdmin={true} isPost={true} />
}

export default AdminPostsScreen;